import { render, staticRenderFns } from "./TransactionViewGlobal.vue?vue&type=template&id=02a5c27e"
import script from "./TransactionViewGlobal.vue?vue&type=script&lang=js"
export * from "./TransactionViewGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports